import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductionApiError, getFixedOrders } from '../services/productionService';
import type { ProductionFixedOrder } from '../types/production.types';

export interface FixedOrderListState {
  rows: ProductionFixedOrder[];
  loading: boolean;
  error: string | null;
  setError: (value: string | null) => void;
  reload: () => Promise<void>;
}

/**
 * Sabit üretim tanımları. Sekme başlığındaki sayı için sayfa açılınca yüklenir.
 * `enabled` false ise istek atılmaz (yetkisiz yönetici sunucudan 403 alırdı).
 */
export function useFixedOrderList(enabled: boolean): FixedOrderListState {
  const { t } = useTranslation('production');
  const [rows, setRows] = useState<ProductionFixedOrder[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      setRows(await getFixedOrders());
    } catch (err) {
      setError(err instanceof ProductionApiError ? err.message : t('fixedOrders.loadFailed'));
    } finally {
      setLoading(false);
    }
  }, [enabled, t]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { rows, loading, error, setError, reload };
}
